import React from "react";
import ourMission from "../images/our-mission.svg";
import whoWeAre from "../images/who-we-are.svg";
import { useTranslation } from "react-i18next";

const AboutServices = () => {
  const {t} = useTranslation();
  return (
    <div className="mt-[30px] md:mt-[50px] sm:mt-28 flex justify-center">
      <div className="xl:max-w-[1000px] 3xl:max-w-[1200px]">
        <div className="md:container md:mx-auto">
          <div className="grid sm:grid-cols-1 md:grid-cols-2 sm:gap-[0%] md:gap-[14%] my-[12px] sm:my-[20px] lg:my-[70px] mx-[16px] sm:mx-[16px] 3xl:my-[100px] 3xl:mt-[54px] lg:mt-[40px]">
            <div className="flex sm:justify-center order-2 md:order-1 md:justify-start px-[15px] sm:px-[30px] md:px-[0px]">
              <img draggable="false" src={ourMission} className="h-[200px]  sm:h-[300px] md:h-[auto] w-[100%] sm:w-[auto]  3xl:w-[600px] rounded-[10px] object-contain " alt="ourMissionImg" />
            </div>
            <div className="flex items-center  order-1 md:order-2">
              <div className="text-center md:text-left">
                <h1 className="sora text-[20px] sm:text-[28px] 3xl:text-[54px] font-[700] leading-[30px] sm:leading-[40px] 3xl:leading-[60px] text-[#000]">
                  {t("our")}
                </h1>
                <h1 className="sora text-[22px] sm:text-[32px] 3xl:text-[54px] font-[700]  leading-[30px] sm:leading-[40px] 3xl:leading-[60px] text-[#000]">
                  {" "}
                  {t("mission")}
                </h1>
                <p className="sora text-[14px] 3xl:text-[18px] font-[400]  text-[#444] mt-2 sm:mt-4">
                  {t("mission_desc1")} {" "}
                </p>
                <p className="sora text-[14px] 3xl:text-[18px] font-[400]  text-[#444] mt-1 sm:mt-6">
                  {t("mission_desc2")}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="md:container md:mx-auto">
          <div className="grid sm:grid-cols-1 md:grid-cols-2 sm:gap-[0%] md:gap-[15%]  sm:my-[50px] md:my-[70px] mx-[16px] 3xl:my-[120px]">
            <div className="flex items-center">
              <div className="pt-[20px] sm:pt-[0px] text-center md:text-left ">
                <h1 className="sora text-[22px] sm:text-[32px] 3xl:text-[54px] font-[700]  leading-[30px] sm:leading-[40px] 3xl:leading-[60px] text-[#000]">
                  {t("who")}
                </h1>
                <h1 className="sora text-[22px] sm:text-[32px] 3xl:text-[54px] font-[700]  leading-[30px] sm:leading-[40px] 3xl:leading-[60px] text-[#000]">
                  {t("we_are")}
                </h1>
                <p className="sora text-[14px] 3xl:text-[18px] font-[400]  text-[#444] mt-2 sm:mt-4">
                  {t("who_we_are_desc1")}
                </p>
                <p className="sora text-[14px] 3xl:text-[18px] font-[400]  text-[#444]  mt-1 sm:mt-6">
                 {t("who_we_are_desc2")}
                </p>
              </div>
            </div>
            <div className="flex sm:justify-center md:order-1 md:justify-start px-[15px] sm:px-[30px] md:px-[0px]">
              <img draggable="false" src={whoWeAre} className="h-[200px]  sm:h-[300px] md:h-[auto] w-[100%] sm:w-[auto]  3xl:w-[600px] rounded-[10px] object-contain " alt="WhoAreImage" />
            </div>
          </div>
        </div>

      </div>

    </div>
  );
};

export default AboutServices;
